'use client';

import { useRef } from 'react';
import Drawer from '@/features/drawer';
import { useDrawer } from '@/features/drawer/context/use-drawer';
import { IconSearchNormal } from '@/components/svg-symbols/icons';
import { SearchDrawerName } from '../../constants';
import { SearchBox } from '../../search';
function MobileSearch() {
  const queryInput = useRef<HTMLInputElement>(null);
  const {
    openDrawer
  } = useDrawer();
  const handleClick = () => {
    if (queryInput.current?.focus) {
      setTimeout(() => queryInput?.current?.focus(), 500);
    }
  };
  return <>
            <label onClick={() => openDrawer(SearchDrawerName)} className='mr-auto flex cursor-pointer items-center gap-2 rounded-lg text-xs text-neutral-500 lg:hidden'>
                <IconSearchNormal onClick={handleClick} className='h-6 w-6 text-text-black' data-sentry-element="IconSearchNormal" data-sentry-source-file="mobile-search.tsx" />
            </label>

            <Drawer name={SearchDrawerName} position='bottom' data-sentry-element="Drawer" data-sentry-source-file="mobile-search.tsx">
                <div className='relative flex h-14 w-full justify-center px-2 text-text-black shadow-sm'>
                    <SearchBox mode='mobile' ref={queryInput} data-sentry-element="SearchBox" data-sentry-source-file="mobile-search.tsx" />
                </div>
            </Drawer>
        </>;
}
export default MobileSearch;